import { Component, input, output, signal } from '@angular/core';
import { CommonModule, NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NExpeConfig } from '../../nexpe.model';
import { FeatureCheckboxComponent } from '../feature-checkbox/feature-checkbox.component';
import { CutoffEditorComponent } from '../cutoff-editor/cutoff-editor.component';

@Component({
  selector: 'app-nexpe-detail-modal',
  imports: [
    CommonModule,
    NgClass,
    TranslateModule,
    FeatureCheckboxComponent,
    CutoffEditorComponent,
  ],
  templateUrl: './nexpe-detail-modal.component.html',
  styleUrl: './nexpe-detail-modal.component.scss',
})
export class NexpeDetailModalComponent {
  nexpe = input<NExpeConfig | null>(null);
  isOpen = input<boolean>(false);
  isEditMode = input<boolean>(false);
  modalClose = output<void>();
  save = output<NExpeConfig>();
  delete = output<string>();
  configChange = output<NExpeConfig>();

  showNexpeCodeError = signal(false);

  onClose(): void {
    this.modalClose.emit();
  }

  onSave(): void {
    const config = this.nexpe();
    if (config && config.nexpe) {
      this.showNexpeCodeError.set(false);
      this.save.emit(config);
    } else {
      this.showNexpeCodeError.set(true);
    }
  }

  onDelete(): void {
    const config = this.nexpe();
    if (config && config.nexpe) {
      this.delete.emit(config.nexpe);
    }
  }

  onFeatureToggle(field: keyof NExpeConfig): void {
    const config = this.nexpe();
    if (config) {
      this.configChange.emit({ ...config, [field]: !config[field] });
    }
  }

  onNexpeChange(value: string): void {
    const config = this.nexpe();
    if (config) {
      this.configChange.emit({ ...config, nexpe: value });
    }
    if (this.showNexpeCodeError() && value) {
      this.showNexpeCodeError.set(false);
    }
  }

  onNameChange(value: string): void {
    const config = this.nexpe();
    if (config) {
      this.configChange.emit({ ...config, name: value });
    }
  }

  onContactChange(field: 'customerService' | 'food4rest', value: string): void {
    const config = this.nexpe();
    if (config) {
      this.configChange.emit({ ...config, [field]: value });
    }
  }

  onCutOffChange(cutOff: any): void {
    const config = this.nexpe();
    if (config) {
      this.configChange.emit({ ...config, cutOff });
    }
  }

  onBackdropClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('m-nexpeModal__backdrop')) {
      this.onClose();
    }
  }
}
